import axiosInstance from "./api_helper";

const deliveryService = {

    list: async ({ clientId, shiftId, commercialId, dateFrom, dateTo, recordedFrom, recordedTo, sansFacture, query, amount, paymentFilter, sortField, sortDirection, status, page, size }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (shiftId !== undefined && shiftId !== null && shiftId !== '') params.shiftId = shiftId;
        if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (recordedFrom) { params.recordedFrom = recordedFrom; params.dateFrom = recordedFrom.slice(0, 10); }
        if (recordedTo) { params.recordedTo = recordedTo; params.dateTo = recordedTo.slice(0, 10); }
        if (query) params.query = query;
        if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;
        if (paymentFilter) params.paymentFilter = paymentFilter;
        if (sortField) params.sortField = sortField;
        if (sortDirection) params.sortDirection = sortDirection;
        if (status) params.status = status;
        if (sansFacture) params.sansFacture = sansFacture;
        if (page !== undefined && page !== null) params.page = page;
        if (size !== undefined && size !== null) params.size = size;

        const response = await axiosInstance.get('/api/ventes/bon-livraison', { params });

        return response.data;
    },
    totals: async ({ clientId, shiftId, commercialId, dateFrom, dateTo, sansFacture, query, amount, byCaisse }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (shiftId !== undefined && shiftId !== null && shiftId !== '') params.shiftId = shiftId;
        if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;
        if (amount !== undefined && amount !== null && amount !== '') params.amount = amount;
        if (sansFacture !== undefined && sansFacture !== null) params.sansFacture = sansFacture;
        if (byCaisse !== undefined && byCaisse !== null) params.byCaisse = byCaisse;

        const response = await axiosInstance.get('/api/ventes/bon-livraison/totals', { params });
        return response.data;
    },

    listImpayesComptoir: async ({ clientId}) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        const response = await axiosInstance.get('/api/ventes/bon-livraison/comptoir/impaye', { params });
        return response.data;
    },

    listImpayes: async ({ clientId}) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;

        const response = await axiosInstance.get('/api/ventes/bon-livraison/impaye', { params });

        return response.data;
    },

    annulerBL: async (id) => {
        return axiosInstance.delete(`/api/ventes/bon-livraison/annuler/${id}`);
    },

    resetBL: async (id) => {
        return axiosInstance.put(`/api/ventes/bon-livraison/reset/${id}`);
    },


    listComptoire: async ({ clientId, shiftId, commercialId, dateFrom, dateTo, recordedFrom, recordedTo, query, page, size }) => {
        const params = { shiftId, page, size };
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (commercialId !== undefined && commercialId !== null) params.commercialId = commercialId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (recordedFrom) { params.recordedFrom = recordedFrom; params.dateFrom = recordedFrom.slice(0, 10); }
        if (recordedTo) { params.recordedTo = recordedTo; params.dateTo = recordedTo.slice(0, 10); }
        if (query) params.query = query;

        const response = await axiosInstance.get('/api/ventes/bon-livraison/caisse', { params });
        return response.data;
    },

    add: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison-direct', deliveryData.data);
    },
    addBL: async (deliveryData) => {
        return await axiosInstance.post('/api/ventes/bon-livraison/creer', deliveryData.data);
    },
    update: async (id, data) => {
        try {
            const response = await axiosInstance.put(`/api/ventes/bon-livraison/${id}`, JSON.stringify(data));
            return response;
        } catch (error) {
            throw error;
        }
    },
    generatePdf: async (deliveryDTO) => {
        const response = await axiosInstance.post(`/api/deliveryNotes/report`, deliveryDTO, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    delete: async (deliveryId) => {
        const response = await axiosInstance.delete(`/api/deliveryNotes/${deliveryId}`);
        return response.data;
    },
    filter: async (query) => {
        return axiosInstance.post(`/api/deliveryNotes/search`, JSON.stringify(query));
    },
    getLastSaved: async () => {
        return await axiosInstance.get(`/api/deliveryNotes/last-saved`);
    },

    findByReference: async (reference) => {
        const params = {};
        params.numero = reference;
        const response = await axiosInstance.get(`/api/ventes/bon-livraison/reference`, { params });
        return response.data;
    },
    uploadBLs: async (payload) => {
        return axiosInstance.post(`/api/ventes/bon-livraison/upload`, payload.formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    getBonLivraisonsNonRegles: async (payload) => {
        const { clientId, chantierId } = payload || {};
        const q = new URLSearchParams();
        if (clientId) q.append("clientId", clientId);
        if (chantierId) q.append("chantierId", chantierId);
        return axiosInstance.get(`/api/ventes/bon-livraisons/non-regles?${q.toString()}`);
    }
}

export default deliveryService;
